import Url from 'urijs';
import { isEmpty } from 'lodash';

import { buildTargetUrlPreservingParams } from 'Utils/uri/uriUtils';
import { PHONE_URL_PROTOCOL } from './constants';

function getUrl(sUrl) {
  return new Url(sUrl);
}

function sameHostname(previousUrl, nextUrl) {
  return (
    isEmpty(nextUrl.hostname()) ||
    (previousUrl.hostname() === nextUrl.hostname() && previousUrl.port() === nextUrl.port())
  );
}

export function getSpaUrl(url) {
  return getUrl(url.pathname())
    .query(url.query())
    .hash(url.hash())
    .toString();
}

function isPhoneNumberUrl(url) {
  return url.protocol() === PHONE_URL_PROTOCOL;
}

class DynamicLinkUtil {
  constructor(previousUrl, nextUrl, options) {
    if (!(this instanceof DynamicLinkUtil)) {
      return new DynamicLinkUtil(previousUrl, nextUrl, options);
    }
    this.previousUrl = previousUrl ? getUrl(previousUrl) : new Url();
    this.nextUrl = getUrl(nextUrl);
    this.targetUrl = this.isExternalUrl()
      ? this.nextUrl
      : buildTargetUrlPreservingParams(this.previousUrl, this.nextUrl, options);
  }

  isSpaUrl() {
    return !this.isExternalUrl() && !this.hashToSamePage() && !isPhoneNumberUrl(this.nextUrl);
  }

  hashToSamePage() {
    return (
      !isEmpty(this.nextUrl.hash()) &&
      (isEmpty(this.nextUrl.pathname()) || this.nextUrl.pathname() === this.previousUrl.pathname())
    );
  }

  isExternalUrl() {
    return !sameHostname(this.previousUrl, this.nextUrl) || isPhoneNumberUrl(this.nextUrl);
  }

  toString() {
    return this.isSpaUrl() ? getSpaUrl(this.targetUrl) : this.targetUrl.toString();
  }

  hash() {
    return this.targetUrl.hash();
  }
}

export default DynamicLinkUtil;
